<script>
  // Jobs uploaded but not yet queued. The only page with an upload form.
  import JobList from "./JobList.svelte";
  import ReadyCard from "../FileCard/ReadyCard.svelte";
  import UploadFile from "../UploadFile.svelte";
</script>

<JobList
  url="/file/ready"
  title="Ready"
  emptyMessage="No jobs are ready"
  emptyHint="Upload a Python script above to add one."
  emptyIcon="fa-file-upload"
  let:file
  let:refresh
>
  <svelte:fragment slot="top">
    <!-- The "Deleting scenario please wait" popup used to be mounted here,
         behind its own store. It is a toast now -- see lib/toast.js -- and the
         Toaster lives once in App.svelte.

         UploadFile posts natively and the server redirects to "/", so there is
         no in-SPA event to refresh on: the page reloads itself. -->
    <UploadFile />
  </svelte:fragment>

  <ReadyCard
    fileId={file.id}
    filename={file.file_name}
    uploadedDateTime={file.upload_date}
    on:changed={refresh}
  />
</JobList>
